import { performRequest } from "./api-handler";
import { URLS } from "../utility/urls";

export default () => {
  const {
    GET_APP_MODULES_DETAILS,
    ADD_APP_MODULES_DETAILS,
    UPDATE_APP_MODULES_DETAILS,
    DELETE_APP_MODULES_DETAILS,
  } = URLS;

  return {
    getAppModulesDetails: (body = {}, method = "get") =>
      performRequest(method ? method : "get", GET_APP_MODULES_DETAILS, body),
    addAppModulesDetails: (body = {}, method = "post") =>
      performRequest(method ? method : "post", ADD_APP_MODULES_DETAILS, body),
    updateAppModulesDetails: (body = {}, method = "put") =>
      performRequest(method ? method : "put", UPDATE_APP_MODULES_DETAILS, body),
    deleteAppModulesDetails: (body = {}, method = "delete") =>
      performRequest(method ? method : "delete", DELETE_APP_MODULES_DETAILS, body),
  };
};

